import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSProgress = {
    name: 'VS in Progress',
    imageUrl: '../../images/VSProgress.png',
    imageSize: "99%",
    bradius: 20,
  };

export const VSProgress = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Vulnerability Scans in Progress</b><br/><br/>
      See vulnerability scans live as they run. Any scan that is currently running live will be displayed 
      in a vulnerability scan table similar to the one shown on the right. <br/><br/>
      The information displayed includes scan names, the individuals who issued the scans, number of 
      targets with completed and currently running scans, progress percentage on each scan, and the 
      vulnerabilities found so far broken down by severity. There is also an Action column that 
      allows you to pause or delete scans. <br/><br/>
      As a default, the display will show 10 results. However, depending on the volume of scans being 
      performed, there are additional features allowing you to search or apply filters to find the 
      information you need quickly.<br/><br/>
      You can change the number of scans to display by clicking on the numeric 10 at the top right or 
      use the search box to look for specific scans. You can also filter results by by type of scan 
      (Internal Authenticated, Internal Unauthenticated, External, Web App). <br/><br/>
      Pause or Delete a Scan <br/>
      Within the Scans in Progress table, you can create an action - either delete a scan or temporarily 
      pause a scan. Use the pause or delete icons in the Action column to do this. <br/><br/>
      Pausing a vulnerability scan allows systems administrators to perform system maintenance tasks 
      on targets that are the current subject of a scan. A vulnerability scan may be resumed at the 
      completion of the system maintenance. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSProgress.imageUrl}
        alt={'Image of ' + UIVSProgress.name}
        style={{
          width: UIVSProgress.imageSize,
          borderRadius: UIVSProgress.bradius,
        }}
      />
      </div>
    </div>
  );
};

